/**
 * @file 打日志统计
 * @author rongtan <rongtan@baidu.com>
 */

import ubc from '@baidu/ubc-report-sdk';
import {merge} from '@baidu/exp-utils';
import PAGE_CONFIG from '@const/page-config';
import {getPagePath} from './page-path';

const UBC_ID = 11447;

function getCurPageName() {
    const name = PAGE_CONFIG[getPagePath()] ? PAGE_CONFIG[getPagePath()].name : '';
    return name;
}

const globalConfig = {
    testMode: process.env.NODE_ENV === 'development',
    version: '2.0',
    from: 'gemh5',
    page: getCurPageName(),
    source: encodeURIComponent(document.referrer),
    timestamp: Date.now(),
    autoPvTrack: false,
    timingId: UBC_ID,
    autoTimingTrack: false,
    queryParams: {
        appname: 'zhaocaimao'
    },
    ext: {
        url: encodeURIComponent(window.location.href)
    }
};

ubc('init', UBC_ID, globalConfig);

/**
 * 数据统计
 *
 * eg:
 * // 打pv点
 * sendUbcLog('pv');
 * // 打页面时长点
 * sendUbcLog('timing');
 * // 打展现点
 * sendUbcLog('view', {value: 'card', ext: {element_id: 123}});
 * // 打点击点
 * sendUbcLog('clk', {value: 'btn'}, ()=>{invoke(scheme)});
 * // 打其他类型点
 * sendUbcLog(type, data, cb);
 * @param {string} type 日志类型
 * @param {Object} data 公参和扩展参数
 * @param {Function} cbk 回调函数，发送埋点后执行的操作
 */
export function sendLog(type, data, cb = () => {}) {
    const param = {
        ext: {
            url: encodeURIComponent(window.location.href)
        }
    };

    if (typeof data === 'function') {
        cb = data;
        data = null;
    }
    switch (type) {
        case 'pv':
            merge(param, {type: 'view', value: 'page'}, data);
            ubc('pv', param);
            break;

        case 'timing':
            ubc('config', {duration: 10});
            // 多页面应用，不需要 'end', 保持多端一致
            ubc('timing', 'start', 'timing');
            break;

        default:
            merge(param, {type}, data);
            ubc('event', param, cb);
            break;
    }
}
